/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ProjectSettingsServiceDeskPortalSettingsType from '@jira/spa-apps__project-settings-service-desk-classic-portal-settings/src/ClassicPortalSettings.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsServiceDeskClassicPortalSettings: LazyComponent<
	() => React.JSX.Element
> = lazyForPaint<typeof ProjectSettingsServiceDeskPortalSettingsType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-project-settings-service-desk-classic-portal-settings", jiraSpaEntry: "async-project-settings-service-desk-classic-portal-settings" */ '@jira/spa-apps__project-settings-service-desk-classic-portal-settings/src/ClassicPortalSettings.tsx'
		),
	),
);

const AsyncProjectSettingsServiceDeskClassicPortalSettings = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProjectSettingsServiceDeskClassicPortalSettings}
		pageId="project-settings-classic-portal-settings"
		shouldShowSpinner
	/>
);

export default AsyncProjectSettingsServiceDeskClassicPortalSettings;
